import React from 'react';
import {
  Zap,
  BookOpen,
  Radio,
  Database,
  Boxes,
  Activity,
  Shield,
  Sparkles,
  Mail,
  Rocket,
  LogIn,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  zap: Zap,
  book: BookOpen,
  radio: Radio,
  database: Database,
  boxes: Boxes,
  activity: Activity,
  shield: Shield,
  sparkles: Sparkles,
  mail: Mail,
  rocket: Rocket,
  login: LogIn,
};

export function SidebarIcon(props: { name?: string; className?: string }) {
  const name = props.name?.trim();
  if (!name) return null;
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon aria-hidden="true" className={props.className ?? 'h-4 w-4 opacity-80'} />;
}
